import React, { useState, useMemo, useEffect } from "react";
import "../../design/removeCounties.css";

const RemoveCounties = ({ isOpen, onClose, userSubscriptions = [], availableCounties = [] }) => {
  const [selectedToRemove, setSelectedToRemove] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const token = localStorage.getItem("access_token");

  useEffect(() => {
    if (isOpen) {
      setSelectedToRemove([]); 
    }
  }, [isOpen]); 

  const userCountyDetails = useMemo(() => {
    return userSubscriptions
      .map((sub) => {
        const county = availableCounties.find((c) => c.id === sub.county_id);
        return county ? { ...county, subscriptionId: sub.id } : null;
      })
      .filter(Boolean);
  }, [userSubscriptions, availableCounties]);

  const currentTotal = useMemo(() => {
    return userCountyDetails.reduce((sum, c) => sum + c.price, 0);
  }, [userCountyDetails]);

  const newTotal = useMemo(() => {
    return userCountyDetails
      .filter((c) => !selectedToRemove.includes(c.id))
      .reduce((sum, c) => sum + c.price, 0);
  }, [userCountyDetails, selectedToRemove]);

  const toggleRemove = (id) => {
    setSelectedToRemove((prev) =>
      prev.includes(id) ? prev.filter((cId) => cId !== id) : [...prev, id]
    );
  };

  const handleSubmit = async () => {
    if (selectedToRemove.length === 0) return;

    setLoading(true);
    setErrorMsg("");

    try {
      const res = await fetch("https://api.deliquentauction.com/subscriptions/unsubscribe-many/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(selectedToRemove),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || "Failed to remove counties");
      }

      alert("Counties removed successfully. Changes will take effect next billing cycle.");
      onClose();
    } catch (err) {
      setErrorMsg(err.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="removecounty-modal-overlay">
      <div className="removecounty-modal">
        <button className="close-button" onClick={onClose}>✖</button>
        <h2>Remove Counties</h2>

        {userCountyDetails.length === 0 ? (
          <p>You have no active subscriptions.</p>
        ) : (
          <>
            <p>Select counties to remove. Changes apply next billing cycle.</p>
            {userCountyDetails.map((county) => (
              <div key={county.id} className="removecounty-item">
                <label>
                  <input
                    type="checkbox"
                    checked={selectedToRemove.includes(county.id)}
                    onChange={() => toggleRemove(county.id)}
                  />
                  {county.name}, {county.state} - {county.industry} - ${county.price.toFixed(2)}
                </label>
              </div>
            ))}
          </>
        )}

        <div className="removecounty-total">
          <p><strong>Current Monthly Total:</strong> ${currentTotal.toFixed(2)}</p>
          <p><strong>New Monthly Total:</strong> ${newTotal.toFixed(2)}</p>
        </div>

        <button
          onClick={handleSubmit}
          disabled={loading || selectedToRemove.length === 0}
        >
          {loading ? "Processing..." : "Remove Selected Counties"}
        </button>

        {errorMsg && <p className="error-msg">{errorMsg}</p>}
      </div>
    </div>
  );
};

export default RemoveCounties;
